'use strict';

require('../CompanyService.js');

function CompanySettingTaskStatusesCtrl(
  $scope,
  taskStatuses,
  translations,
  $stateParams,
  $state,
  $window,
  CompanyService,
  growl
) {
  // Task statuses
  $scope.taskStatuses = taskStatuses;
  $scope.addTaskStatus = function() {
    $scope.taskStatuses.push({
      name: '',
      color: 4279856278,
      type: 'CUSTOME'
    });

    $scope.lastItemTaskStatuses = $scope.taskStatuses.length - 1;
  };

  $scope.saveTaskStatuses = function() {
    angular.forEach($scope.taskStatuses, function(taskStatus){
      if(!taskStatus.id){
        taskStatus.code = taskStatus.name;
      }
    });
    CompanyService.updateTaskStatuses({companyId: $stateParams.companyId}, $scope.taskStatuses, function() {
      $state.reload();
      growl.addSuccessMessage(translations['settings.save-status-tasks-success']);
    });
  };
}

CompanySettingTaskStatusesCtrl.resolve = {
  taskStatuses: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
    return CompanyService.queryTaskStatuses({companyId: $stateParams.companyId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
     'settings.save-status-tasks-success'
    ]);
  }]
};
module.exports = CompanySettingTaskStatusesCtrl;

angular.module('dokiv')
  .controller('CompanySettingTaskStatusesCtrl', [
  '$scope',
  'taskStatuses',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'CompanyService',
  'growl',
  CompanySettingTaskStatusesCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingTaskStatusesCtrl.js
// module id = 414
// module chunks = 0